module.exports = __webpack_public_path__ + "img/copaAmerica213.e4ef9695.jpg";